module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/babel-loader/lib/index.js??clonedRuleSet-4.use[0]!./nl.js"));
	}, "locale/nl");
}